/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2019-11-13.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2019-11-13.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2019-11-13.mdx';

const metadata = {
  slug: "2019-11-13",
  title: "React Native Up and Running",
  author: "Christian Battaglia",
  description: "Getting React Native set up from scratch — NVM, Watchman, Xcode, Android Studio, and the first steps toward building a cross-platform mobile app.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-11-13T00:00:00.000Z",
  
  readTime: "4 min read",
  tags: ["React Native","React","Expo","mobile development","Spotify","SSH","iOS","Android"],
};

export const Route = createFileRoute('/blog/posts/2019-11-13')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2019-11-13',
    image: '/og/blog/2019-11-13.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
